import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  GET_MUSICSTORE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/musicstore', params: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  GET_MUSICSTORE_SERVICE : {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/musicstore', params: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  PUT_MUSICSTORE_SERVICE: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'put', url: '/musicstore/'+ payload.id, data: payload.params})
      .then(result =>{
          return result
      })
    }
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
